import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    getTranslations(locale) {
        return axios.get(ApiRouteProvider.i18n.translations(locale));
    },

    switchLanguage(language) {
        return axios.post(ApiRouteProvider.i18n.switchLanguage(), {'language' : language});
    },

    getLanguages() {
        return new Promise((resolve) => {
           resolve({
               data: [
                   {
                       title: 'English',
                       code: 'en'
                   },
                   {
                       title: 'Swedish',
                       code: 'sv'
                   }
               ]
           })
        });
    }
};
